import {useState, useContext, useEffect} from 'react';
import {UserContext, UpdateUserContext} from "../../App"
import {tab_color_bg} from "../config/Config"
import {useFetch} from "../hooks/useFetch"
import {useMsg} from "../hooks/useMsg"
import {pluriel} from "../Fonctions"
import {AdminControl} from "../AdminControl"

export function CompteConfig () {
  document.title = 'Compte Config'
  const {currentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)
  // Dates
  const dat = new Date()
  const dat_month = dat.getMonth()+1 < 10 ? '0'+ (dat.getMonth()+1) : dat.getMonth()+1
  const dat_day = dat.getDate() < 10 ? '0'+ (dat.getDate()) : dat.getDate()
  //const today = dat.getFullYear() + '-' + dat_month + '-' + dat_day

  let tab_period = {}

  let liste_classes = []
  user.liste_classes?.forEach(classe => tab_period[classe] = [])

  const [data_config, setData_config] = useState({
    nom:user.nom,
    prenom:user.prenom,
    genre:undefined,
    action: 'config_periodes',
    active_period:false,
    active_period_all_classes:false,
    modif_period:{classe:'', p:0},
    periodes:user.periodes?.length ? user.periodes : tab_period,
    niv_ens:''
  })
  console.log('data_config : ', data_config)

  const {data, fetchApi} = useFetch()
  useEffect(()=>{
    fetchApi('api-msg', {user})
  },[]);

  const {msg, setMsg} = useMsg()
  //console.log(data)
  //const {msg2, setMsg2, cleanMsg2} = useMsg()
  //console.log(msg2, setMsg2, cleanMsg2)

  // ================= Config ================= 
  const genre = ['Mme', 'Mlle', 'M.'].map((e, k)=><span key={k} onClick={() => setData_config({...data_config, genre:e})} ><label><input type="radio" name="genre" />&nbsp;{e} &nbsp; &nbsp; &nbsp; </label></span>)
  const niv_ens = ['collège', 'lycée', 'prépa', 'IUT', 'faculté', 'autre'].map((e, k)=><span key={k} className={'btn_param'+(e === data_config?.niv_ens ? ' active' : '')} onClick={()=>setData_config({...data_config, niv_ens:e})} >{e}</span> )
  // ===================================== 


  // =========== Période =========== 
  const [tab_period_base, setTab_period_base] = useState([
    '2023-09-01_2023-11-15',
    '2023-11-16_2024-03-10',
    '2024-03-11_2024-06-25',
  ])
  const [period_base_modif, setPeriod_base_modif] = useState(null)

  tab_period['5e2'] = tab_period_base.slice() // copie de period base
  tab_period['3e3'] = [
    '2023-09-01_2023-01-20',
    '2023-01-21_2024-07-07',
  ]
  // =============================== 

  const start_month = (period) => period.split('-')[1]
  const start_day = (period) => period.split('_')[0].split('-')[2]
  const end_month = (period) => period.split('-')[3]
  const end_day = (period) => period.split('-')[4]
  const end_year = (period) => period.split('_')[1].split('-')[0]

  const handleChange = (e) => {
    const classe = e.target.name.split('_')[0]
    const p = e.target.name.split('_')[2]
    const val = e.target.value
    const period = classe ? data_config.periodes[classe][p] : tab_period_base[p]
    const nb_periodes = classe ? data_config.periodes[classe].length : tab_period_base.length
    const new_period = period.replace(period.split('_')[e.target.name.split('_')[3]*1], val)
    let tab_period = classe ? data_config.periodes[classe] : tab_period_base
    tab_period[p] = new_period
    let tab = ''
    if(e.target.name.split('_')[3]*1 === 0 && p > 0) {
      tab = tab_period[p-1]
      tab = tab.split('-')
      tab[3] = start_month(val)
      tab[4] = start_day(val)*1 > 10 ? start_day(val)*1 - 1 : (start_day(val)*1 > 1 ? '0'+(start_day(val)*1 - 1) :start_day(val))
      tab_period[p-1] = tab.join('-')
    }
    if(e.target.name.split('_')[3]*1 === 1 && p < nb_periodes-1) {
      tab = tab_period[p*1+1]
      tab = tab.split('-')
      tab[1] = val.split('-')[1]
      tab[2] = val.split('-')[2]*1 < 28 && val.split('-')[2]*1 > 10 ? val.split('-')[2]*1 + 1 : (val.split('-')[2]*1 < 9 ? '0'+(val.split('-')[2]*1 + 1) : val.split('-')[2])
      tab[2] += '_'+end_year(tab_period[p*1+1])
      tab_period[p*1+1] = tab.join('-')
    }
    
    if (classe) {
      console.log('data_config period', data_config.periodes)
      const periodes = {...data_config.periodes, [classe]:tab_period}
      setData_config({...data_config, periodes, modif_period:{classe:'', p:0}})
      //console.log('data_config period', data_config.periodes)
      //console.log('data_config modified')
    } else {
      setTab_period_base(tab_period)
      setPeriod_base_modif(null)
      //console.log('tab_period modified')
    }
  }

  const handleSubmit = (e)=> {
    setMsg('---- ', 'success')
  }

  const affiche_periode = (classe, p) => {
    const period = classe ? data_config.periodes[classe][p] : tab_period_base[p]
    const period_start = period.split('_')[0]
    const period_end = period.split('_')[1]
    const p1 = ' du ' + start_day(period) +  '/'+ start_month(period)
              +' au ' + end_day(period) + '/'+ end_month(period)

    let type_periode = 'Période'
    if(classe) {
      type_periode = data_config.periodes[classe].length === 3 ? 'Trimestre' : (data_config.periodes[classe].length === 2 ? 'Semestre' : 'Période')
    } else {
      type_periode = tab_period_base.length === 3 ? 'Trimestre' : (tab_period_base.length === 2 ? 'Semestre' : 'Période')
    }
    
    return classe ?  //  =============   Afficher la période de la classe =============
    <div key = {p} >
      <b>{type_periode + ' ' + (p+1)}</b> : {p1} <span title="Modifier la période" style={{cursor:'pointer', marginLeft:'10px'}} onClick={()=>setData_config({...data_config, modif_period:{classe, p}})} >⚙️</span>
      <br/>
      {
        data_config.modif_period.classe == classe && data_config.modif_period.p == p ? 
        <div className="diff_cadre">
          <span className="teal">Modifier la période {p+1} :</span><br/><br/>
          du <input type="date" name={classe+'_periode_'+p+'_0'} value={period_start} min={p > 0 ? data_config.periodes[classe][p-1].split('_')[1] : ''} max={period_end} onChange={handleChange} /> au <input type="date" name={classe+'_periode_'+p+'_1'}  value={period_end} min={period_start} onChange={handleChange}/>
        </div> :''
      }
    </div> : //  =============   Afficher la période de base =============
    <div key = {p+100} > 
      <b>{type_periode + ' ' + (p+1)}</b> : {p1}  <span title="Modifier la période" name={p1} style={{cursor:'pointer', marginLeft:'10px'}} onClick={()=>setPeriod_base_modif(p)} >⚙️</span><br/>
      {
        (period_base_modif === p) && 
        <div className="diff_cadre">
          <span className="teal">Modifier la période {p+1} :</span><br/><br/>
          du <input type="date" name={'_periode_'+p+'_0'} value={period_start} min={p > 0 ? period[p-1].split('_')[1] : ''} max={period_end} onChange={handleChange} /> au <input type="date" name={'_periode_'+p+'_1'}  value={period_end} min={period_start} onChange={handleChange}/><br/><br/>
        </div>
      } 
    </div>
  }


  const addPeriod = (classe=null, add=true) => {
    let tab = classe ? data_config.periodes[classe] : tab_period_base
    if (add) {
      const period = tab.slice(-1)[0]
      const new_month = end_month(period)*1+1 < 10 ? '0'+(end_month(period)*1+1) : ((end_month(period)*1+1)==13 ? '01' : end_month(period)*1+1)
      const last_day = end_day(period)*1+1 < 10 ? '0'+(end_day(period)*1+1) : (end_day(period)*1 < 28 ? end_day(period)*1+1 : end_day(period)*1)
      const new_year = new_month === '01' ? period.slice(11,15)*1+1 : period.slice(11,15)
      const new_period = period.slice(11,18)+'-'+last_day+'_'+new_year+'-'+new_month+'-27'
      
      tab = [...tab, new_period]
    } else {
      tab = tab.slice(0,-1)
    }

    if (classe) {
      const periodes = {...data_config.periodes, [classe]:tab}
      setData_config({...data_config, periodes, modif_period:{classe:'', p:0}})
    } else {
      setTab_period_base(tab)
    }
  }

  liste_classes = user.liste_classes?.map((classe, k) => {
    return <div className="message resultat" key={k} style={{backgroundColor:tab_color_bg[k], maxHeight:'100vh'}}>
      <div className='info_mess'>{user.mes_classes[classe].length} élève{user.mes_classes[classe].length>1 ? 's':''}</div>
      <div className="note_serie">{classe}</div>
      <br/>Périodes 
      <br/>
      {//======= Afficher les périodes =======
        data_config.periodes[classe]?.length ? 
          <>
            {data_config.periodes[classe].map((e,k) => affiche_periode(classe, k))}
            <button title={"supprimer une période"} onClick={()=>addPeriod(classe, false)}> -</button>
            <button title={"ajouter une période"} onClick={()=>addPeriod(classe)}>+</button>  
          </>
          : <div className="btn_param" onClick={()=>setData_config({...data_config, periodes:{...data_config.periodes, [classe]:tab_period_base}})}>Activer</div>
      }
      <br/><br/>
      {/*Groupes : <div className="btn_param">Activer</div>
      <br/>
      {data_config.modif_period.classe == classe && <button className="btn center"> Valider </button>}*/}

    </div>
  })
  
  //console.log(data_config.periodes)
  //console.log(user)
  return (
    <div className="onglet_content">
    	<h1>Mes infos et configuration de compte</h1>
    	<div name="Mes infos" className="content" style={{textAlign: "left"}}>
        <h1>Mes infos</h1>
        {genre}<br/>
        Nom : {user.nom}<br/>
        Prénom : {user.prenom}<br/>
        Numéro d'identification : 20-{user.id}-22<br/>
        J'enseigne en {niv_ens}
    	</div>
      <div name="Mes stats" className="content" style={{textAlign: "left"}}>
        <h1>Mon compte</h1>
        Modifier mon mot de passe : <button className="btn">Modifier</button> <br/>
        Nombres de classes créées : {user.liste_classes?.length} classe{pluriel(user.liste_classes?.length)}<br/>
      </div>
    	<div name="Mes classes" className="content" style={{textAlign: "left", width:'100%'}}>
	    	<h1>Mes périodes</h1>
        Activer une même période pour toutes mes classes ? <div className={'btn_param '+(data_config.active_period_all_classes ? 'active' : '')} onClick={()=>setData_config({...data_config, active_period_all_classes:!data_config.active_period_all_classes})}>{data_config.active_period_all_classes ? 'Oui' : 'Non'}</div>
        {
          (user.liste_classes && data_config.active_period_all_classes) &&
          <div className="diff_cadre" style={{width:'400px'}} ><br/>
          <span className="teal"><b>Période commune à toutes mes classes</b></span><br/><br/>
          {tab_period_base.map((e,k) => affiche_periode(false, k))}

          {
            tab_period_base.length > 1 ? <>
              <button title={"supprimer une période"} onClick={()=>addPeriod('', false)}> -</button>
            </> :''
          }
          <button title={"ajouter une période"} onClick={()=>addPeriod()}>+</button> 
          <br/>
          <br/>

            <button name="Activ_Period_ForAll" className="btn standard" onClick={()=>{
                user.liste_classes?.forEach(classe=>tab_period[classe] = [...tab_period_base]) 
                setData_config({...data_config, periodes:tab_period, active_period_all_classes:false})
              }}>Activer
            </button>
          </div>
        }
        <br/>
	    	{liste_classes}
    	</div>

      <span dangerouslySetInnerHTML={{ __html:msg}}></span>
      <div align="center"><button className='btn' onClick={handleSubmit}>Valider mes infos</button></div>
      
      {/* =============== Admin ================== 
      <AdminControl name={'data_config'} data={data_config} />*/}
    </div>
  );
}